<!--  -->
<template>
  <div class>
    <van-nav-bar
      title="购票须知"
      left-arrow
      @click-left="onClickLeft"
    />
    <display-description :value="description" style="marginBottom:100px;" />
  </div>
</template>
<script>
import Vue from 'vue';
import { NavBar } from 'vant';
import DisplayDescription from '@/components/DisplayDescription.vue';

Vue.use(NavBar);
export default {
  components: {
    DisplayDescription,
  },
  data() {
    return {
      description: '',
    };
  },
  computed: {},
  watch: {},
  methods: {
    onClickLeft() {
      this.$router.push('/tickets_list')
    },
  },
  created() {
    this.description = sessionStorage.getItem('ticketInstructions');
  },
};
</script>
<style lang='less' scoped>
</style>